import "./App.css";
import "antd/dist/antd.less";
import { useState, useContext, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { UserContext, UserProvider } from "./UserContext";
import { getLoggedInUser } from "./APIManager";
import LoginPage from "./Components/LoginPage/LoginPage";
import MainLayout from "./Components/MainLayout/MainLayout";

import { GetCMSDoc } from "./APIManager";
import { ConfigContext } from "./ConfigContext";

import { GetAgeBracketInfo } from "./utility";

function App() {
  const [user, setUser] = useContext(UserContext);
  const [config, setConfig] = useContext(ConfigContext);
  const [isResolved, setResolved] = useState(false);
  const [currentPath, setCurrentPath] = useState("");
  const [fetchedConfig, SetFetchedConfig] = useState(false);

  useEffect(() => {
    FetchUserDetails(
      isResolved,
      setUser,
      currentPath,
      setCurrentPath,
      setResolved
    );
  });

  useEffect(() => {
    FetchConfig();
  }, []);

  function FetchConfig() {
    GetCMSDoc("ControlPanelFormSetup").then((res) => {
      const newConfig = {
        ...config,
        cpConfig: { ...res.data.Data, ...InjectConfig(res.data.Data) },
      };
      setConfig(newConfig);
      console.log(newConfig);
      SetFetchedConfig(true);
    });
  }

  function InjectConfig(cpConfig) {
    const {
      U25YOBLowerLimit,
      U21YOBLowerLimit,
      U18YOBLowerLimit,
      U15YOBLowerLimit,
    } = GetAgeBracketInfo(cpConfig);

    const U25AllowedYOBs = `${U25YOBLowerLimit}, ${U25YOBLowerLimit + 1}, ${
      U25YOBLowerLimit + 2
    }, and ${U25YOBLowerLimit + 3}`;

    const U21AllowedYOBs = `${U21YOBLowerLimit}, ${U21YOBLowerLimit + 1}, and ${
      U21YOBLowerLimit + 2
    }`;

    const U18AllowedYOBs = `${U18YOBLowerLimit}, ${U18YOBLowerLimit + 1}, and ${
      U18YOBLowerLimit + 2
    }`;

    const U15AllowedYOBs = `${U15YOBLowerLimit} or after`;

    return {
      U25YOBLowerLimit,
      U21YOBLowerLimit,
      U18YOBLowerLimit,
      U15YOBLowerLimit,
      U25AllowedYOBs,
      U21AllowedYOBs,
      U18AllowedYOBs,
      U15AllowedYOBs,
    };
  }

  if (!isResolved || !fetchedConfig) {
    return (
      <div
        style={{
          display: "flex",
          height: "100vh",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <h1>Loading</h1>
      </div>
    );
  }

  return (
    <Router>
      <Switch>
        <Route path="/login">
          <LoginPage />
        </Route>
        <Route path="*">
          <MainLayout />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;

function FetchUserDetails(
  isResolved,
  setUser,
  currentPath,
  setCurrentPath,
  setResolved
) {
  //  console.log("hooray");
  if (isResolved !== true) {
    getLoggedInUser().then((res) => {
      // console.log(res);
      setUser(res.data);
      setCurrentPath(window.location.href);
      setResolved(true);
    });
    //setResolved(true);
  } else {
    if (currentPath !== window.location.href) {
      getLoggedInUser().then((res) => {
        // console.log(res);
        setUser(res.data);
        setResolved(true);
      });
      setCurrentPath(window.location.href);
    }
  }
}
